<div
    class='agpr-rightSidebar'
    [ngClass]="{
        'agpr-rightSidebar--collapsible': collapsible && overlayContainer,
        'agpr-rightSidebar--contentCollapsible': contentCollapseToggle,
    }"
    [ngStyle]="{
        'width': collapsible
            ? (!overlay ? '40px' : 'calc(40px + ' + (contentWidth || '30vw') + ')')
            : (contentWidth ? 'calc(40px + ' + contentWidth + ')' : undefined)
    }"
    (clickOutside)="clickOutside($event)"
    [clickOutsideEnabled]="!!overlay"
    [exclude]="clickOutsideExcluded"
    [excludeBeforeClick]="true"
>
    @if (contentCollapseToggle) {
        <div class="contentCollapseToggle agpr-contentToggle">
            <agpr-button
                [style]="buttonTypes.icon"
                [icon]="contentCollapsed ? 'fa-solid fa-angle-left' : 'fa-solid fa-angle-right'"
                [tooltip]="contentCollapsed ? 'Core.expand' : 'Core.collapse'"
                (click)="toggleContent()"
            ></agpr-button>
            <div class="agpr-contentToggle-line"></div>
        </div>
    }
    <div
        #container
        class="agpr-rightSidebar-container"
        [class.agpr-rightSidebar-container--expanded]="_expanded"
        [class.agpr-rightSidebar-container--contentCollapsed]="contentCollapsed"
        [@contentCollapse]="contentCollapseAnimation"
        (@contentCollapse.done)="contentCollapseComplete($event)"
        [@slide]="slideAnimation"
        (@slide.done)="slideAnimationComplete($event)"
        [agprLoading]="entityLoading || loadingSearch && (outletContactTabTypesEnum.recommendedSearch !== currentTab)"
    >
        <!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
        <ul
            *ngIf="tabs?.length > 0 || _outletContactTabs?.length > 0"
            class="agpr-rightSidebar-tabs"
            [ngClass]="{'agpr-rightSidebar-tabs-useWhiteBg': useWhiteBg}"
            role="tablist"
            [attr.aria-orientation]="orientation"
            (keyup)="onKeyUp($event)"
        >
            <ng-container *ngFor="let tab of _outletContactTabs">
                <div
                    *ngIf="!tab.hidden && outletContactTabsVisible"
                    class="agpr-rightSidebar-tabContainer"
                >
                    <li
                        class="agpr-rightSidebar-tab"
                        [ngClass]="{
                            'agpr-rightSidebar-tab--selected': tab.selected,
                            'agpr-rightSidebar-tab--disabled': tab.disabled,
                            'agpr-rightSidebar-tabs--spacer': tab.showSpacer,
                            'agpr-rightSidebar-tabs--spacerAfter': tab.showSpacerAfter
                        }"
                        [id]="tab.id"
                        [agprTooltip]="tab.tooltip | localize"
                        [showDelay]="500"
                        tooltipPosition="left"
                        [attr.aria-label]="tab.tooltip | localize"
                        (click)="selectTab(tab)"
                        role="tab"
                        [attr.aria-controls]="tab.id + '.panel'"
                        [attr.aria-selected]="tab.selected ? true : false"
                    >
                    @if(tab.icon !== 'fa-kit-duotone fa-agpr-notes'){
                        <i [class]="getIconClasses(tab)"></i>
                    }
                    @else{
                    <span class="fa-layers fa-fw agpr-rightSidebar-tab-container">
                        <i [class]="getIconClasses(tab)"></i>
                        @if(notesLength >= 10|| notesLength === 1) {
                        <div>
                            <span
                                [class]="tab.selected? 'agpr-rightSidebar-tab-noteText agpr-rightSidebar-tab-noteText-decimalNoteText agpr-rightSidebar-tab-noteText-selected'                                                                                                                                     :'agpr-rightSidebar-tab-noteText agpr-rightSidebar-tab-noteText-decimalNoteText'">
                                {{notesLength >= 10 ? '9': notesLength}}
                            </span>
                            @if(notesLength >= 10){
                                <span
                                    [class]="tab.selected? 'agpr-rightSidebar-tab-noteText agpr-rightSidebar-tab-noteText-selected agpr-rightSidebar-tab-noteText-plusNoteText'                                                                                                                                   :'agpr-rightSidebar-tab-noteText agpr-rightSidebar-tab-noteText-plusNoteText'">+
                                </span>
                            }
                        </div>
                        }
                        @else {
                            <span [class]="tab.selected? 'agpr-rightSidebar-tab-noteText agpr-rightSidebar-tab-noteText-selected'
                                :'agpr-rightSidebar-tab-noteText'">
                                {{notesLength}}
                            </span>
                        }
                    </span>
                    }
                    </li>
                    <div
                        *ngIf="!tab.hidden"
                        class="agpr-rightSidebar-tabBar"
                        [ngClass]="{
                            'agpr-rightSidebar-tabBar--selected': tab.selected,
                            'agpr-rightSidebar-tabBar--spacer': tab.showSpacer,
                            'agpr-rightSidebar-tabBar--spacerAfter': tab.showSpacerAfter
                        }"
                    >
                    </div>
                </div>
            </ng-container>
            <ng-container *ngFor="let tab of tabs">
                <div
                    *ngIf="!tab.hidden"
                    class="agpr-rightSidebar-tabContainer"
                >
                    <li
                        class="agpr-rightSidebar-tab"
                        [ngClass]="{
                            'agpr-rightSidebar-tab--selected': tab.selected,
                            'agpr-rightSidebar-tab--disabled': tab.disabled,
                            'agpr-rightSidebar-tab--spacer': tab.showSpacer
                        }"
                        [id]="tab.id"
                        [agprTooltip]="tab.tooltip | localize"
                        [showDelay]="500"
                        tooltipPosition="left"
                        [attr.aria-label]="tab.tooltip | localize"
                        (click)="selectTab(tab)"
                        role="tab"
                        [attr.aria-controls]="tab.id + '.panel'"
                        [attr.aria-selected]="tab.selected ? true : false"
                    >
                    <i [class]="getIconClasses(tab)"></i>
                    </li>
                    <div
                        class="agpr-rightSidebar-tabBar"
                        [ngClass]="{
                            'agpr-rightSidebar-tabBar--selected': tab.selected,
                            'agpr-rightSidebar-tabBar--spacer': tab.showSpacer
                        }"
                    >
                    </div>
                </div>
            </ng-container>
        </ul>
        <!-- eslint-enable @angular-eslint/template/interactive-supports-focus -->
        <div
            *ngIf="showExtendedContent && tabExtended"
            class="agpr-rightSidebar-extended"
            [@fade]="fadeAnimation"
            (@fade.done)="fadeAnimationComplete($event)"
        >
            <agpr-scroll-panel>
                <div class="agpr-rightSidebar-scrollArea agpr-rightSidebar-scrollArea--noHeader agpr-rightSidebar-scrollArea--noFooter">
                    <ng-container *ngTemplateOutlet="tabExtended"></ng-container>
                </div>
            </agpr-scroll-panel>
        </div>
        <div
            *ngIf="!tabs || tabs.length < 1 || _selectedTabIndex !== null"
            class="agpr-rightSidebar-contents"
            [ngClass]="{'agpr-rightSidebar-contents-useWhiteBg': useWhiteBg}"
            [ngStyle]="{ 'width': contentWidth }"
        >
            <div
                *ngIf="(header || tabHeader)"
                class="agpr-rightSidebar-header"
            >
                <h3
                    *ngIf="showTabTitle"
                    class="agpr-rightSidebar-title"
                >
                    <span class="agpr-rightSidebar-title-text">{{ tabTitle | localize }}</span>
                    @if (isRecentCoverage) {
                        <span
                            role="img"
                            class="agpr-rightSidebar-info fa-regular fa-circle-info"
                            [agprTooltip]="'Discover.targeting.rhp.tabs.recentCoverageHeader.toolTipInfo' | localize: {count: hasMonitoringPermissions ? 25 : 10}"
                            tooltipPosition="bottom"
                            [interactiveTooltip]="true"
                        ></span>
                    }
                </h3>
                <div *ngIf="header">
                    <ng-container *ngTemplateOutlet="header"></ng-container>
                </div>
                <div *ngIf="tabHeader">
                    <ng-container *ngTemplateOutlet="tabHeader"></ng-container>
                </div>
            </div>
            <div
                #contentContainer
                class="agpr-rightSidebar-content"
            >
                <agpr-scroll-panel
                    #scrollPanel
                    (scrolledTopChange)="onScroll($event)"
                >
                    <div
                        class="agpr-rightSidebar-scrollArea agpr-rightSidebar-scrollAreaHeight"
                        [class.agpr-rightSidebar-scrollArea--noHeader]="!header && !tabHeader"
                        [class.agpr-rightSidebar-scrollArea--noFooter]="!footer && !tabFooter"
                    >
                        <h3
                            *ngIf="!(header || tabHeader) && showTabTitle"
                            class="agpr-rightSidebar-title"
                        >
                            {{ tabTitle | localize }}
                        </h3>
                        <div *ngIf="content">
                            <ng-container *ngTemplateOutlet="content"></ng-container>
                        </div>
                        <div class="agpr-rightSidebar-scrollArea-container">
                            <!-- Renders the additional tabs' content if they're selected -->
                            <ng-content></ng-content>
                            <ng-container *ngIf="!_hideOutletContactTabs">
                                <agpr-tab
                                    *ngIf="showAiSearchSummary"
                                    [id]="'_' + id + '_targetingRhpTab.recommendedSearchSummary'"
                                    icon="fa-kit-duotone fa-agpr-ai-summary"
                                    [showSpacerAfter]="true"
                                    tooltip="Discover.targeting.rhp.tabs.searchSummary"
                                >
                                    <agpr-recommended-search-summary></agpr-recommended-search-summary>
                                </agpr-tab>
                                <agpr-entity-details-tab
                                    #contactProfile
                                    [id]="'_' + id + '_targetingRhpTab.contactProfile'"
                                    [hidden]="entityType !== entityTypes.CONTACT || targetingRhpContextsService.hideContactProfile"
                                    icon="fa-user"
                                    tooltip="Discover.targeting.rhp.tabs.profileMeta"
                                    [entityType]="entityTypes.CONTACT"
                                    [fullHeightProfileTakeover]="fullHeightTakeover"
                                    [hiddenNoContentMessage]="hiddenNoContentMessage"
                                    [noContactMessage]="'Monitor.entityProfile.noContact'"
                                    [disableFullProfile]="disableContentToggle"
                                    (loading)="entityLoading = $event"
                                ></agpr-entity-details-tab>
                                <agpr-entity-details-tab
                                    #outletProfile
                                    [id]="'_' + id + '_targetingRhpTab.outletProfile'"
                                    [hidden]="targetingRhpContextsService.hideOutletProfile"
                                    icon="fa-kit-duotone fa-agpr-outlet"
                                    tooltip="Discover.targeting.rhp.tabs.outletProfileMeta"
                                    [entityType]="entityTypes.OUTLET"
                                    [fullHeightProfileTakeover]="fullHeightTakeover"
                                    [hiddenNoContentMessage]="hiddenNoContentMessage"
                                    [disableFullProfile]="disableContentToggle"
                                    (loading)="entityLoading = $event"
                                ></agpr-entity-details-tab>
                                <agpr-staff-search-tab
                                    #staffSearchTab
                                    [id]="'_' + id + '_targetingRhpTab.staffSearch'"
                                    [hidden]="entityType !== entityTypes.OUTLET"
                                    icon="fa-users"
                                    tooltip="Discover.targeting.rhp.tabs.staff"
                                    [isActive]="_selectedTabIndex === outletContactTabKeys.indexOf(outletContactTabTypesEnum.staffSearch)"
                                    [hideBusinessCard]="hideBusinessCard"
                                    (showRhpTakeOver)="spawnStaffProfileTakeover($event)"
                                ></agpr-staff-search-tab>
                                <agpr-affiliates-tab
                                    #affiliatesTab
                                    [id]="'_' + id + '_targetingRhpTab.affiliates'"
                                    [hidden]="entityType !== entityTypes.OUTLET"
                                    icon=" fa-sitemap"
                                    tooltip="Discover.targeting.rhp.tabs.affiliates"
                                    [isActive]="_selectedTabIndex === outletContactTabKeys.indexOf(outletContactTabTypesEnum.affiliates)"
                                    [hideBusinessCard]="hideBusinessCard"
                                    (showRhpTakeOver)="spawnOutletProfileTakeover($event)"
                                ></agpr-affiliates-tab>
                                <agpr-list-membership-tab
                                    [id]="'_' + id + '_targetingRhpTab.listMembership'"
                                    icon="fa-kit-duotone fa-agpr-lists"
                                    tooltip="Discover.targeting.rhp.tabs.listMemberships"
                                    [hideBusinessCard]="hideBusinessCard"
                                ></agpr-list-membership-tab>
                                <agpr-recent-coverage-tab
                                    #recentCoverageTab
                                    [id]="'_' + id + '_targetingRhpTab.recentCoverage'"
                                    icon=" fa-newspaper"
                                    tooltip="Discover.targeting.rhp.tabs.recentCoverage"
                                    [isActive]="_selectedTabIndex === outletContactTabKeys.indexOf(outletContactTabTypesEnum.recentCoverage)"
                                    [entity]="entityType === entityTypes.CONTACT ? contact : outlet"
                                    [contactPrivateData]="contactPrivateData"
                                    [outletPrivateData]="outletPrivateData"
                                    [hideBusinessCard]="hideBusinessCard"
                                    (showRhpTakeOver)="spawnOutletProfileTakeover($event)"
                                ></agpr-recent-coverage-tab>
                                <agpr-interaction-view-tab
                                    #interactionViewTab
                                    [id]="'_' + id + '_targetingRhpTab.interactionView'"
                                    [entity]="entityType === entityTypes.CONTACT ? contact : outlet"
                                    [contactPrivateData]="contactPrivateData"
                                    [outletPrivateData]="outletPrivateData"
                                    (selectedEmploymentChanged)="targetingRhpContextsService.changeSelectedEmployment($event.id)"
                                    icon=" fa-paper-plane"
                                    tooltip="Discover.targeting.rhp.tabs.interactionView"
                                    [hideBusinessCard]="hideBusinessCard"
                                ></agpr-interaction-view-tab>
                                <agpr-tab
                                    [id]="'_' + id + '_targetingRhpTab.notes'"
                                    [icon]="'fa-kit-duotone fa-agpr-notes'"
                                    tabTitle ="Discover.targeting.rhp.tabs.notes"
                                    [tooltip]="'Discover.targeting.rhp.tabs.notes.tooltip' | localize: { numberOfNotes: notesLength }"
                                >
                                    @if (!hideBusinessCard) {
                                        <ng-template #tabHeader>
                                            <agpr-entity-business-card
                                                [id]="id + '_rhpContextsBusinessCard'"
                                                [isRHP]="true"
                                                [canOpenFullProfile]="false"
                                                [entity]="entityType === entityTypes.CONTACT ? contact : outlet"
                                                [contactPrivateData]="contactPrivateData"
                                                [outletPrivateData]="outletPrivateData"
                                                (selectedEmploymentChanged)="targetingRhpContextsService.changeSelectedEmployment($event.id)"
                                                [isCondensedMode]="true"
                                                [showOutletInfo]="true"
                                            ></agpr-entity-business-card>
                                        </ng-template>
                                    }

                                    <agpr-targeting-notes
                                        [disableOutletAddNotes]="outlet?.liveness === outletLiveness.PENDING"
                                        [_entityType]="entityType"
                                        (notesLengthNumber)="updateNotesLength($event)"
                                    >
                                    </agpr-targeting-notes>
                                </agpr-tab>
                            </ng-container>
                        </div>
                    </div>
                </agpr-scroll-panel>
            </div>
            <div
                *ngIf="(footer || tabFooter) && showFooter"
                class="agpr-rightSidebar-footer"
            >
                <div
                    *ngIf="tabFooter"
                >
                    <ng-container *ngTemplateOutlet="tabFooter"></ng-container>
                </div>
                <div
                    *ngIf="footer"
                >
                    <ng-container *ngTemplateOutlet="footer"></ng-container>
                </div>
            </div>
        </div>
    </div>
</div>
